export default __webpack_public_path__ + "static/media/team4.1b4e06b7.JPG";